
import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';

interface UserAvatarProps {
  src?: string | null;
  fullName?: string | null;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const UserAvatar = ({ src, fullName, className, size = 'md' }: UserAvatarProps) => {
  const getInitials = (name: string | null | undefined): string => {
    if (!name) return '??';
    
    const names = name.trim().split(' ');
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    
    const firstInitial = names[0].charAt(0).toUpperCase();
    const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
    
    return `${firstInitial}${lastInitial}`;
  };

  const sizeClasses = {
    sm: 'h-8 w-8 text-sm',
    md: 'h-10 w-10 text-base',
    lg: 'h-12 w-12 text-lg',
    xl: 'h-16 w-16 text-xl'
  };

  return (
    <Avatar className={cn(sizeClasses[size], className)}>
      <AvatarImage 
        src={src || undefined} 
        alt={fullName || 'User'}
        onError={(e) => {
          console.error('UserAvatar image failed to load:', e.currentTarget.src);
          e.currentTarget.style.display = 'none';
        }}
      />
      <AvatarFallback className="bg-primary text-primary-foreground font-semibold">
        {getInitials(fullName)}
      </AvatarFallback>
    </Avatar>
  );
};

export default UserAvatar;
